<div class="pd-export pd-import">
  <ng-template #confirmDeleteFormatModalTpl let-modal>
    <div class="modal-header" style="background: transparent">
      <button type="button" class="close" aria-label="Fermer" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" style="padding: 30px 64px 64px">
      <h2 class="text-center">Confirmer la suppression</h2>
      <p class="mb-2">Voulez-vous supprimer ce format d’import ?</p>
      <div
        class="justify-content-center"
        style="display: flex; flex-wrap: wrap; align-items: center; margin-top: 12px; gap: 8px"
      >
        <button
          type="button"
          class="btn"
          style="background: rgba(128, 131, 144, 0.16); color: rgba(128, 131, 144, 1)"
          (click)="modal.dismiss()"
        >
          Annuler
        </button>
        <button
          type="button"
          class="btn"
          style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
          [disabled]="deletingFormatId != null"
          (click)="confirmerSuppressionDepuisPopup(modal)"
        >
          Supprimer
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Grille des modèles (à l’ouverture de l’onglet) -->
  <ng-container *ngIf="afficherListeModeles">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
      <span class="small font-weight-bold mb-0">Modèles d’import</span>
      <button
        type="button"
        class="btn rippleEffect"
        style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
        (click)="openNouveauFormatModal()"
      >
        <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>
        Nouveau format
      </button>
    </div>
    <div class="row g-3 mb-2" *ngIf="formats.length">
      <div class="col-12 col-sm-6 col-lg-4" *ngFor="let f of formats; let idx = index" style="margin-bottom: 24px">
        <button
          type="button"
          class="pd-export__model-card card h-100 text-start w-100 border-0"
          (click)="ouvrirModele(f)"
        >
          <div class="card-body py-3 px-3">
            <div class="pd-export__model-badge small text-muted mb-1">Modèle {{ idx + 1 }}</div>
            <div class="font-weight-bold text-body">{{ f.nom }}</div>
            <div class="text-muted small">{{ f.extension }}</div>
            <button
              type="button"
              class="btn btn-sm btn-danger mt-2"
              title="Supprimer"
              aria-label="Supprimer le format"
              [disabled]="deletingFormatId != null"
              (click)="ouvrirPopupConfirmationSuppression(f, $event)"
            >
              Supprimer
            </button>
          </div>
        </button>
      </div>
    </div>
    <p *ngIf="!formats.length" class="text-muted small mb-0">
      Aucun format — créez-en un avec « Nouveau format » ou vérifiez l’API.
    </p>
  </ng-container>

  <!-- Détail : format + mapping + fichier + simulation -->
  <ng-container *ngIf="!afficherListeModeles">
    <div class="mb-2">
      <button
        type="button"
        class="btn btn-link btn-sm text-body p-0 pd-export__back-modeles"
        (click)="retourListeModeles()"
      >
        <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>
        Modèles
      </button>
    </div>

    <div class="d-flex flex-wrap justify-content-between align-items-end mb-3 gap-2">
      <div class="d-flex flex-wrap align-items-end gap-2 flex-grow-1 pd-export__format-row">
        <div class="pd-export__format-field">
          <label class="small mb-0 mr-2 d-block">Format d’import</label>
          <ng-select
            class="ng-select-custom pd-export__format-select"
            [items]="formats"
            [compareWith]="compareImportFormats"
            bindLabel="nom"
            [clearable]="false"
            [searchable]="true"
            [loading]="deletingFormatId != null"
            [disabled]="!formats.length"
            placeholder="Aucun format — créez-en un ou vérifiez l’API"
            notFoundText="Aucun format"
            [(ngModel)]="selectedFormat"
            name="importFmtNg"
            (change)="onFormatChange()"
          >
            <ng-template ng-label-tmp let-item="item">
              <span *ngIf="item">{{ item.nom }} <span class="text-muted small">({{ item.extension }})</span></span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="text-truncate d-block">
                {{ item.nom }}
                <span class="text-muted small">({{ item.extension }})</span>
              </span>
            </ng-template>
          </ng-select>
        </div>
        <button
          type="button"
          class="btn btn-danger btn-sm pd-mapping-delete-btn"
          title="Supprimer le format sélectionné"
          aria-label="Supprimer le format sélectionné"
          [disabled]="!selectedFormat || !formats.length || deletingFormatId != null"
          (click)="supprimerFormatSelectionne()"
        >
          <i class="bi bi-dash" aria-hidden="true"></i>
        </button>
      </div>
      <button
        type="button"
        class="btn rippleEffect"
        style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
        (click)="openNouveauFormatModal()"
      >
        <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>
        Nouveau format
      </button>
    </div>

    <div *ngIf="selectedFormat" class="alert alert-light border small mb-3">
      {{ selectedFormat.description }}
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
      <h6 class="small font-weight-bold mb-0">Mapping import</h6>
      <button
        type="button"
        class="btn rippleEffect"
        style="background: rgba(128, 131, 144, 0.16); color: rgba(128, 131, 144, 1)"
        (click)="saveMapping()"
        [disabled]="!selectedFormat || mappingLoading || savingMapping"
      >
        {{ savingMapping ? 'Enregistrement…' : 'Enregistrer le mapping' }}
      </button>
    </div>
    <p *ngIf="mappingLoading" class="text-muted small mb-2">Chargement du mapping…</p>
    <div class="pd-export__table-shell mb-2">
      <div class="pd-export__table-wrap mb-2" [class.pd-export__table-loading]="mappingLoading">
        <table class="table table-hover mb-0 pd-import__mapping-table">
          <thead class="custom-header">
            <tr>
              <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9)">Colonne fichier</th>
              <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9)">Champ cible</th>
              <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9)">Transformation</th>
              <th
                class="pd-mapping-actions text-center"
                style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 52px"
                scope="col"
                aria-label="Supprimer"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of mapping; let i = index">
              <td>
                <input
                  class="form-control form-control-sm"
                  [(ngModel)]="m.colonneFichier"
                  [name]="'cf' + i"
                  [disabled]="mappingLoading || savingMapping"
                />
              </td>
              <td>
                <ng-select
                  *ngIf="isProductsModule"
                  class="ng-select-custom pd-export__col-select pt-0 pb-0"
                  [items]="productAttributeOptions"
                  bindLabel="key"
                  bindValue="key"
                  [(ngModel)]="m.champCible"
                  [name]="'icc' + i"
                  [disabled]="mappingLoading || savingMapping"
                  [clearable]="true"
                  [searchable]="true"
                  [addTag]="true"
                  placeholder="Attribut (key)"
                  notFoundText="Aucun attribut"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div class="d-flex flex-column align-items-stretch w-100 py-1">
                      <span class="d-flex justify-content-between align-items-center gap-2">
                        <span class="font-weight-500">{{ item.key }}</span>
                        <span *ngIf="item.type" class="text-muted small text-nowrap ms-1">{{ item.type }}</span>
                      </span>
                    </div>
                  </ng-template>
                </ng-select>
                <input
                  *ngIf="!isProductsModule"
                  class="form-control form-control-sm"
                  [(ngModel)]="m.champCible"
                  [name]="'cc' + i"
                  [disabled]="mappingLoading || savingMapping"
                />
              </td>
              <td>
                <input
                  class="form-control form-control-sm"
                  [(ngModel)]="m.transformation"
                  [name]="'tr' + i"
                  [disabled]="mappingLoading || savingMapping"
                />
              </td>
              <td class="text-center align-middle pd-mapping-actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm pd-mapping-delete-btn"
                  (click)="supprimerLigneMapping(i)"
                  [disabled]="mapping.length <= 1 || mappingLoading || savingMapping || deletingRowIndex === i"
                  title="Supprimer la ligne"
                  aria-label="Supprimer la ligne"
                >
                  <i class="bi bi-dash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mb-3 p-0" style="margin-top: 12px">
      <b
        style="color: rgba(19, 74, 211, 1); cursor: pointer"
        [class.text-muted]="mappingLoading || savingMapping"
        [style.pointer-events]="mappingLoading || savingMapping ? 'none' : 'auto'"
        (click)="ajouterLigneMapping()"
      >Ajouter une ligne</b>
    </div>

    <label class="small font-weight-bold d-block mb-2">Fichier source</label>
    <input
      #fileIn
      type="file"
      class="d-none"
      accept=".csv,.txt,.xlsx,.xls"
      (change)="onFile($event)"
    />
    <div
      class="pd-export__dest pd-import__drop border rounded p-4 mb-3 text-center"
      [class.pd-import__drop--active]="dragOver"
      (click)="triggerFile()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
    >
      <i class="bi bi-cloud-arrow-up d-block mb-2" style="font-size: 2rem; color: #134ad3"></i>
      <p class="mb-1 font-weight-500">Déposez un fichier ici ou cliquez pour parcourir</p>
      <p class="mb-2 text-muted small">CSV, TXT, Excel — aperçu des premières lignes en local</p>
      <pre *ngIf="previewLines.length" class="pd-export__preview text-start small mb-0 border rounded p-2">{{ previewLines.join('\n') }}</pre>
    </div>

    <button
      type="button"
      class="btn btn-primary rippleEffect"
      (click)="runSimulation()"
      [disabled]="simulating"
    >
      {{ simulating ? 'Simulation en cours…' : 'Lancer la simulation d’import' }}
    </button>
    <p *ngIf="simulationResult" class="text-success small mt-2 mb-0">{{ simulationResult }}</p>
  </ng-container>
</div>

<ng-template #nouveauFormatModalTpl let-modal>
  <div class="modal-header" style="background: transparent">
    <button type="button" class="close" aria-label="Fermer" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="padding: 30px 64px 64px">
    <h2 class="modal-title mb-0 text-center">Nouveau format d’import</h2>
    <div class="form-group mt-2">
      <label class="small">Nom <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="nouveauFormatNom"
        name="impNom"
        autocomplete="off"
      />
    </div>
    <div class="form-group mb-0">
      <label class="small">Type <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="nouveauFormatType"
        name="impType"
        placeholder="ex. csv, xlsx"
        autocomplete="off"
      />
    </div>
    <div
      class="justify-content-center"
      style="display: flex; flex-wrap: wrap; align-items: center; margin-top: 12px; gap: 8px"
    >
      <button
        type="button"
        class="btn rippleEffect"
        style="background: rgba(128, 131, 144, 0.16); color: rgba(128, 131, 144, 1)"
        (click)="modal.dismiss()"
        [disabled]="creatingFormat"
      >
        Annuler
      </button>
      <button
        type="button"
        class="btn rippleEffect"
        style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
        (click)="enregistrerNouveauFormat(modal)"
        [disabled]="creatingFormat"
      >
        {{ creatingFormat ? 'Enregistrement…' : 'Enregistrer' }}
      </button>
    </div>
  </div>
</ng-template>
